module.exports = __webpack_public_path__ + "img/logo-homecenter_1.8835ead2.jpg";